module.exports = __webpack_public_path__ + "img/02.dd365946.jpg";